import { Link } from "react-router-dom";
import blogs from "./Blog/blogs";
import { Menu, X, ChevronRight, ChevronsRight } from 'lucide-react';
import { Button } from '@/components/ui/button';

function Aside({ currentSlug }) {
  const relatedBlogs = blogs.filter(
    (blog) => blog.slug !== currentSlug
  );
  

  return (
    <>
    <aside className="bg-gray-000 text-black p-0 shadow">
               <h2 className="text-xl font-bold mb-4 borderb flex items-center justify-between py-3 px-2">Latest Blogs <ChevronsRight /></h2>
       <div className="flex flex-col gap-0 ">

      {relatedBlogs.map((blog) => (
        <Link
          key={blog.id}
          to={`/blog/${blog.slug}`}
          className="border-b pb-3 flex hover:text-[#20293C] py-3 px-1 line-clamp-2 max-w-[315px] " 
        >
          <div className="flex items-top justify-between aside-bar-css">
            <ChevronRight
              size={22}
              className="!w-5 !h-5 shrink-0"
            />
            <span className="min-w-0 flex-1 break-words">
              {blog.title}
            </span>

            
          </div>
                 
        </Link>
      ))}
           </div>
    </aside>

</>
  );
}
export default Aside;
